import { NavLink } from 'react-router-dom'
import NotificationBell from '@/components/ui/NotificationBell'
import { BottomTabContent, bottomTabClass } from '@/components/ui/BottomTab'
import type { NavItem } from './PortalLayout'

/**
 * Phone and tablet navigation for a console with only a handful of screens
 * (the staff production floor). Replaces the whole top bar below `xl`. Five
 * flat slots: two links, the `center` item, notifications, then the rest.
 * Sign out lives on the My Account page, away from where thumbs rest.
 */
export default function PortalBottomNav({ nav }: { nav: NavItem[] }) {
  const visible = nav.filter((item) => !item.hidden)
  const center = visible.find((item) => item.center)
  const sides = visible.filter((item) => !item.center)

  const tab = (item: NavItem) => (
    <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => bottomTabClass(isActive)}>
      <BottomTabContent icon={item.icon} label={item.tabLabel ?? item.label} />
    </NavLink>
  )

  return (
    <nav
      aria-label="Main"
      className="no-print fixed inset-x-0 bottom-0 z-40 border-t border-background/10 bg-primary bg-noise pb-[env(safe-area-inset-bottom)] xl:hidden"
    >
      {/* grid-rows-1 pins the row to the bar height, so no slot can grow it. */}
      <div className="mx-auto grid h-14 max-w-lg grid-cols-5 grid-rows-1">
        {sides.slice(0, 2).map(tab)}
        {center && tab(center)}
        <NotificationBell variant="tab" />
        {sides.slice(2).map(tab)}
      </div>
    </nav>
  )
}
